import { render } from "./InsertScript.vue?vue&type=template&id=0d784695"
import script from "./InsertScript.vue?vue&type=script&lang=js"
export * from "./InsertScript.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ktl/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__